import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import pluralize from "pluralize";
import { memo, useMemo } from "react";
import { AssetMobileVersionsContent } from "~/_components/AssetMobileVersionsContent";
import { AssetMobileVersionsHeader } from "~/_components/AssetMobileVersionsHeader";
import { AssetMobileVersionsList } from "~/_components/AssetMobileVersionsList";
import { AssetMobileVersionsItem } from "~/_components/AssetMobileVersionsListItem";
export const AssetMobileVersions = /*#__PURE__*/ memo((param)=>{
    let { isActiveVersion, onVersionClick, versions = [] } = param;
    const currentVersion = useMemo(()=>{
        return versions[0];
    }, [
        versions
    ]);
    const otherVersions = useMemo(()=>{
        var _versions_slice;
        return (_versions_slice = versions.slice(1)) !== null && _versions_slice !== void 0 ? _versions_slice : [];
    }, [
        versions
    ]);
    return /*#__PURE__*/ _jsxs(AssetMobileVersionsContent, {
        children: [
            /*#__PURE__*/ _jsx(AssetMobileVersionsHeader, {}),
            !!currentVersion && /*#__PURE__*/ _jsx(AssetMobileVersionsList, {
                renderVersion: (version)=>{
                    return /*#__PURE__*/ _jsx(AssetMobileVersionsItem, {
                        isActive: isActiveVersion === null || isActiveVersion === void 0 ? void 0 : isActiveVersion(version),
                        onClick: !!onVersionClick ? ()=>onVersionClick === null || onVersionClick === void 0 ? void 0 : onVersionClick(version) : undefined,
                        version: version
                    }, version.id);
                },
                title: "Cover version",
                versions: [
                    currentVersion
                ]
            }),
            !!otherVersions.length && /*#__PURE__*/ _jsx(AssetMobileVersionsList, {
                renderVersion: (version)=>{
                    return /*#__PURE__*/ _jsx(AssetMobileVersionsItem, {
                        isActive: isActiveVersion === null || isActiveVersion === void 0 ? void 0 : isActiveVersion(version),
                        onClick: !!onVersionClick ? ()=>onVersionClick === null || onVersionClick === void 0 ? void 0 : onVersionClick(version) : undefined,
                        version: version
                    }, version.id);
                },
                title: "Other ".concat(pluralize("version", otherVersions.length, true)),
                versions: otherVersions
            })
        ]
    });
});
AssetMobileVersions.displayName = "AssetMobileVersions";
